export default __webpack_public_path__ + "static/media/Armbands of Vehement Thunder.48a9f6f9.jpg";